import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CostProfile, Identifiable } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  costProfiles: Identifiable<CostProfile>[];
  retrieveCostProfiles(
    request: Boundaries["retrieveCostProfiles"]["request"],
  ): void;
}

function useRetrieveCostProfiles(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isRetrieveCostProfilesRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isRetrieveCostProfilesRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isRetrieveCostProfilesRequestFailure,
    ),
    costProfiles: useSelector(selector.getCostProfiles),
    retrieveCostProfiles: core.retrieveCostProfiles,
  };
}

export { useRetrieveCostProfiles };
